const actions = {
  drawerLogin(state = false, action) {
    switch (action.type) {
      case 'set_drawerLogin':
        return action.payload;
      default:
    }
    return state;
  },
  drawerSearch(state = false, action) {
    switch (action.type) {
      case 'set_drawerSearch':
        return action.payload;
      default:
    }
    return state;
  },
  drawerRegister(state = false, action) {
    switch (action.type) {
      case 'set_drawerRegister':
        return action.payload;
      default:
    }
    return state;
  },
  drawerForgetPwd(state = false, action) {
    switch (action.type) {
      case 'set_drawerForgetPwd':
        return action.payload;
      default:
    }
    return state;
  },
  cart(state = [], action) {
    switch (action.type) {
      case 'SET_CART':
        return action.payload;
      default:
    }
    return state;
  },
  cartCount(state = 0, action) {
    switch (action.type) {
      case 'set_cartCount':
        return action.payload;
      default:
    }
    return state;
  },
  cartTotalAmount(state = 0, action) {
    switch (action.type) {
      case 'set_cartTotalAmount':
        return action.payload;
      default:
    }
    return state;
  },
  myMenus(state = []) {
    return state;
  },
};

export const setDrawerLogin = payload => ({
  type: 'set_drawerLogin',
  payload
});

export const setDrawerSearch = payload => ({
  type: 'set_drawerSearch',
  payload
});

export const setDrawerRegister = payload => ({
  type: 'set_drawerRegister',
  payload
});

export const setDrawerForgetPwd = payload => ({
  type: 'set_drawerForgetPwd',
  payload
});

export const setCartCount = payload => ({
  type: 'set_cartCount',
  payload
});

export const setCartTotalAmount = payload => ({
  type: 'set_cartTotalAmount',
  payload
});


export default actions;
